import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import client, { mensajeDeError } from '../../api/client';
import Badge from '../../components/ui/Badge';
import Spinner from '../../components/ui/Spinner';
import { Entrada, MensajeError } from '../../components/ui/Form';
import { aISO, sumarDias, fechaLegible, horaLegible } from '../../utils/fechas';
import { TituloSeccion, BarraAcciones, TablaEnvoltura, Tabla, SinDatos } from './comunes';

const Seccion = styled.section`
  margin-bottom: ${({ theme }) => theme.space.xl};

  h2 {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.sageDeep};
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;

const Barra = styled.div`
  background: ${({ theme }) => theme.colors.sand};
  border-radius: ${({ theme }) => theme.radii.pill};
  height: 8px;
  min-width: 120px;
  overflow: hidden;

  div {
    height: 100%;
    background: ${({ theme }) => theme.colors.sage};
    border-radius: inherit;
  }
`;

function Reportes() {
  const [desde, setDesde] = useState(() => aISO(sumarDias(new Date(), -30)));
  const [hasta, setHasta] = useState(() => aISO(new Date()));
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState('');

  const cargar = useCallback(() => {
    client
      .get('/admin/reportes', { params: { desde, hasta } })
      .then(({ data }) => setDatos(data))
      .catch((err) => {
        setError(mensajeDeError(err));
        setDatos({ clasesMasLlenas: [], ocupacionPromedio: [], clientesFrecuentes: [] });
      });
  }, [desde, hasta]);

  useEffect(() => {
    setDatos(null);
    cargar();
  }, [cargar]);

  return (
    <>
      <TituloSeccion>Reportes</TituloSeccion>
      <BarraAcciones>
        <label htmlFor="r-desde" style={{ fontSize: '0.85rem' }}>
          Desde
        </label>
        <Entrada id="r-desde" type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
        <label htmlFor="r-hasta" style={{ fontSize: '0.85rem' }}>
          Hasta
        </label>
        <Entrada id="r-hasta" type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
      </BarraAcciones>
      {error && <MensajeError role="alert">{error}</MensajeError>}

      {!datos ? (
        <Spinner />
      ) : (
        <>
          <Seccion>
            <h2>Ocupación promedio por tipo de clase</h2>
            <TablaEnvoltura>
              {datos.ocupacionPromedio.length === 0 ? (
                <SinDatos>Sin datos en este rango.</SinDatos>
              ) : (
                <Tabla>
                  <thead>
                    <tr>
                      <th>Tipo de clase</th>
                      <th>Clases impartidas</th>
                      <th>Ocupación</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {datos.ocupacionPromedio.map((f) => (
                      <tr key={f.tipo_clase}>
                        <td>{f.tipo_clase}</td>
                        <td>{f.total_clases}</td>
                        <td>{f.ocupacion_promedio}%</td>
                        <td>
                          <Barra aria-hidden="true">
                            <div style={{ width: `${f.ocupacion_promedio}%` }} />
                          </Barra>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Tabla>
              )}
            </TablaEnvoltura>
          </Seccion>

          <Seccion>
            <h2>Clases más llenas</h2>
            <TablaEnvoltura>
              {datos.clasesMasLlenas.length === 0 ? (
                <SinDatos>Sin datos en este rango.</SinDatos>
              ) : (
                <Tabla>
                  <thead>
                    <tr>
                      <th>Clase</th>
                      <th>Instructor</th>
                      <th>Fecha</th>
                      <th>Ocupación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datos.clasesMasLlenas.map((c, idx) => (
                      <tr key={idx}>
                        <td>{c.tipo_clase}</td>
                        <td>{c.instructor}</td>
                        <td>
                          {fechaLegible(c.fecha)} · {horaLegible(c.hora_inicio)}
                        </td>
                        <td>
                          <Badge $tono={c.ocupacion >= 90 ? 'exito' : 'arena'}>
                            {c.reservados}/{c.cupo_maximo} ({c.ocupacion}%)
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Tabla>
              )}
            </TablaEnvoltura>
          </Seccion>

          <Seccion>
            <h2>Clientes más frecuentes</h2>
            <TablaEnvoltura>
              {datos.clientesFrecuentes.length === 0 ? (
                <SinDatos>Sin datos en este rango.</SinDatos>
              ) : (
                <Tabla>
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Email</th>
                      <th>Reservas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datos.clientesFrecuentes.map((c) => (
                      <tr key={c.id}>
                        <td>{c.nombre}</td>
                        <td>{c.email}</td>
                        <td>
                          <Badge>{c.total_reservas}</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Tabla>
              )}
            </TablaEnvoltura>
          </Seccion>
        </>
      )}
    </>
  );
}

export default Reportes;
